import { Checkbox, Dropdown, MenuItem } from 'semantic-ui-react'
import styled from 'styled-components'

interface StyledContentWrapperProps {
  topMargin?: string
}

export const StyledMenuItem = styled(MenuItem)`
 .error {
  color: red;
 }
`

export const StyledLeftSideWrapper = styled.div`
width: 380px;
box-shadow: 0 3px 20px rgb(0 0 0 / 4%);
border-radius: 0.375rem;
position: relative;
min-width: 280px;
padding: 1rem;
overflow: hidden;
transform: translateY(10px);
background: rgb(241 245 249);
margin-bottom: 1.25rem;
min-height: 60vh;
 .itemWrapper {
  margin-bottom: 10px;
  cursor: pointer;
  width: 240px;
  padding: 5px;
  font-size: 15px !important;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
  border-radius: 5px;
  &:hover {
    opacity: 0.7 !important;
    background: rgb(210 234 245);
    width: 255px;
  }
 } 
 .active {
  background: rgb(210 234 245);
  } 
 .item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .hoverAction {
    opacity: 0;
    transition: 0.2s ease-out;
  }
  &:hover {
    .hoverAction {
      opacity: 1;
    }
  }
 }
 .itemLeft {  
  display: flex;
  align-items: center;
  gap: 5px;
   .fileNameWrapper {
    display: flex;
    align-items: center;
    gap: 5px;
   }
   .fileName {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
   }
 }
`
export const ModalTextHeader = styled.div`
font-size: 20px !important;
`

export const StyledRightSideWrapper = styled.div`
width: 100%;
box-shadow: 0 3px 20px rgb(0 0 0 / 4%);
border-radius: 0.375rem;
position: relative;
padding-top: 0.5rem;
transform: translateY(10px);
background: rgb(241 245 249);
z-index: 48;
margin-bottom: 1.25rem;
min-height: 60vh;
max-height: 70vh;
 .headerFiles {
  display: flex;
  border: none !important;
  border-radius: 10px !important;
  justify-content: space-between;
  align-items: baseline;
  margin: 0px 15px;
  .title {
    font-size: 18px !important;
    font-weight: bold;
    display: flex;    
    align-items: baseline;
    gap: 10px;
  }
  .titleHeader {    
    font-size: 18px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 300px;
  }
 }
 .content {
  margin-top: 20px;
  padding: 20px 30px;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  min-height: 50vh;
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: hidden;
 }
`
export const StyledFolderWrapper = styled.div`
max-height: 50vh;
overflow-y: auto;
overflow-x: hidden;
`

export const StyledFileCard = styled.div`
position: relative;
transform: translateY(10px);
max-width: 150px;
border-radius: 5px;
transition: transform 0.3s;
width: 150px;
min-height: 200px;
height: 200px;
box-shadow: 0 3px 20px rgb(0 0 0 / 4%);
background-color: white;
z-index: 9;
 &: hover {  
  transform: scale(1.1);
 } 
 .name {
  text-align: center;
  max-width: 120px;
  padding: 0px 10px;
  padding-left: 30px;
  font-style: italic;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;  
 }
`

export const StyledFileCheckbox = styled(Checkbox)`
position: absolute;
left: 5px;
top: 5px;
`
export const StyledFileDropdown = styled(Dropdown)`
position: absolute !important;
right: 0px;
top: 5px;
z-index: 500;
`
export const StyledFilePreviewCounter = styled.div`
position: absolute;
left: 5px;
bottom: 5px;
`
export const StyledFileSize = styled.div`
position: absolute;
right: 5px;
bottom: 5px;
`
export const StyledContentWrapper = styled.div<StyledContentWrapperProps>`
background-position: 50%;
background-repeat: no-repeat;
background-size: contain;
display: block;
position: relative;
width: 60%;
margin-left: auto;
cursor: pointer;
height: 135px;
margin-right: auto;
 .thumbnailWrapper {
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
 }
 * i, img, video {
    object-fit: cover;
    top: ${props => props.topMargin || '10px'};
    width: 100%;
    position: absolute !important;
    height: 100px;
 }
`
export const PrevievWrapper = styled.div`
margin: 30px;
 img, video {
  max-width: 100%;
  display: block;
  width: 100%;
  max-height: 600px;
  object-fit: contain;
  background: #f6f6f6;
 }
`
export const InformationWrapper = styled.div`
display: flex;
justify-content: space-between;
margin-bottom: 15px;
 .label {
  font-weight: bold !important;
 }
 .value {
  color: #6c757d !important;
 }
`

export const TableFooterWrapper = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
width: -webkit-fill-available;
margin: 17px 20px 10px 20px;
`
export const ProgressWrapper = styled.div`
.custom-progress{
  margin-top: 10px;
}
.text-below-progress{
  margin-top: 5px;
  text-align: center;
}
`
